import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

interface DataForSeries extends Omit<RideFormData, 'tripTemplateAttributes'> {
  tripTemplateAttributes?: RideSeriesAttributes;
}
export function getDirtyFieldsForSeries(originalValues: DataForSeries, formValues: DataForSeries) {
  const originalTT = originalValues.tripTemplateAttributes;
  const updatedTT = formValues.tripTemplateAttributes;

  const tripTemplateAttributes = {
    ...(originalTT?.startDate?.toISOString() != updatedTT?.startDate?.toISOString() && {
      startDate: updatedTT?.startDate,
    }),
    ...(originalTT?.endDate?.toISOString() != updatedTT?.endDate?.toISOString() && {
      endDate: updatedTT?.endDate,
    }),
    ...(originalTT?.monday != updatedTT?.monday && {
      monday: updatedTT?.monday,
    }),
    ...(originalTT?.tuesday != updatedTT?.tuesday && {
      tuesday: updatedTT?.tuesday,
    }),
    ...(originalTT?.wednesday != updatedTT?.wednesday && {
      wednesday: updatedTT?.wednesday,
    }),
    ...(originalTT?.thursday != updatedTT?.thursday && {
      thursday: updatedTT?.thursday,
    }),
    ...(originalTT?.friday != updatedTT?.friday && {
      friday: updatedTT?.friday,
    }),
    ...(originalTT?.saturday != updatedTT?.saturday && {
      saturday: updatedTT?.saturday,
    }),
    ...(originalTT?.sunday != updatedTT?.sunday && {
      sunday: updatedTT?.sunday,
    }),
  };

  const moreChecks = sharedChecks(originalValues, formValues);

  return { ...moreChecks, ...(!isEmpty(tripTemplateAttributes) && { tripTemplateAttributes }) };
}

type DataForSingleRide = Omit<RideFormData, 'tripTemplateAttributes'>;
export function getDirtyFieldsForSingleRide(originalValues: DataForSingleRide, formValues: DataForSingleRide) {
  return sharedChecks(originalValues, formValues);
}

function sharedChecks(originalValues: DataForSingleRide, formValues: DataForSingleRide) {
  let haveWaypointsChange = false;

  const originalWPS = originalValues.waypointsAttributes;
  const updatedWPS = formValues.waypointsAttributes;

  if (originalWPS?.length != updatedWPS.length) {
    haveWaypointsChange = true;
  } else {
    for (let i = 0; i < originalWPS.length; i++) {
      const originalWP = originalWPS[i];
      const updatedWP = updatedWPS[i];

      const waypointUpdates = {
        ...(originalWP.anchor != updatedWP.anchor && { anchor: updatedWP.anchor }),
        ...(originalWP.location.id != updatedWP.location.id && { location: updatedWPS[i].location }),
        // Do not run this if anchor because the original anchor waypoints has no riders
        ...(!originalWP.anchor &&
          !isEqual(originalWP.passengerIds, updatedWP.passengerIds) && { passengerIds: updatedWP.passengerIds }),
      };

      if (!isEmpty(waypointUpdates)) {
        haveWaypointsChange = true;
        break;
      }
    }
  }

  return {
    ...(originalValues.calendarSlug != formValues.calendarSlug && { calendarSlug: formValues.calendarSlug }),
    ...(originalValues.tagList != formValues.tagList && { tagList: formValues.tagList }),
    ...(originalValues.timeAnchor != formValues.timeAnchor && { timeAnchor: formValues.timeAnchor }),
    ...(originalValues.anchorTime?.toISOString() != formValues.anchorTime?.toISOString() && {
      anchorTime: formValues.anchorTime,
    }),
    ...(haveWaypointsChange && { waypointsAttributes: formValues.waypointsAttributes }),
    ...(originalValues.time != formValues.time && {
      time: formValues.time,
      anchorTime: formValues.anchorTime,
    }),
  };
}
